var React = require('react');

function DropMenu (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1.25","y1":"1.75","x2":"12.75","y2":"1.75","stroke":"#288002","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("line",{"x1":"14.25","y1":"13.75","x2":"24.75","y2":"13.75","stroke":"#288002","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("line",{"x1":"1.25","y1":"7.75","x2":"24.75","y2":"7.75","stroke":"#288002","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

DropMenu.defaultProps = {"width":"26","height":"15","viewBox":"0 0 26 15","fill":"none"};

module.exports = DropMenu;

DropMenu.default = DropMenu;
